import { render } from "./ContactoEmpresa.vue?vue&type=template&id=35d9389e&scoped=true"
import script from "./ContactoEmpresa.vue?vue&type=script&lang=js"
export * from "./ContactoEmpresa.vue?vue&type=script&lang=js"

import "./ContactoEmpresa.vue?vue&type=style&index=0&id=35d9389e&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d9389e"]])

export default __exports__